export default __webpack_public_path__ + "static/media/boingsfx.908352a7.mp3";